import Header from './Header';
import {useAuth} from '@/auth/useAuth';
import {lastScreenplay} from '@/utils/lastScreenplay';
/** Same public header on standalone routes; workspace keeps its save guard. */
export default function RouteHeader({account=false}:{account?:boolean}){
  const {user}=useAuth();
  return <Header user={user} activePage={account?'account':null} hasActiveScreenplay={!!user&&!!lastScreenplay(user.id)}/>;
}
